// extracted by mini-css-extract-plugin
export default {"container":"container--UMzjj","media":"media--0zwBF","text":"text--7qtSX","blurb":"blurb--0aewP"};